import { List } from 'phosphor-react'

interface BurguerMenuProps {
  onOpenMenu: () => void
}

export const BurguerMenuButton = ({ onOpenMenu }: BurguerMenuProps) => {
  return (
    <button onClick={onOpenMenu}>
      <List size={32} className="text-grey-700" />
    </button>
  )
}
